module.exports = __webpack_public_path__ + "static/media/pdp_paperSmooth.57c38d2f.jpg";